import MentionEditorController from "./mention_editor_controller"

export default class extends MentionEditorController {}
